<ion-button  class="quote-status-button" mode="ios" (click)="navQuote()">{{this.sharedConfig.quoteStatusButtonText}}</ion-button>
